export class SiteMode {
    id: string;
    name: string;
    constructor(siteMode?: SiteMode) {
        this.id = siteMode?.id || "";
        this.name = siteMode?.name || "";
    }
}
